export const decimal = (e) => {
    const decimalPlaces = 2;
    const validCharacters = '0123456789.';
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Shift'];
    
    const keyPressed = e.key;
    const targetValue = e.target.value;

    if (!validCharacters.includes(keyPressed) && !allowedKeys.includes(keyPressed)) {
        e.preventDefault();
    } else {
        if (keyPressed === '.') {
            if (targetValue.includes(keyPressed)) {
                e.preventDefault();
            }
        } else {
            if (targetValue.includes('.')) {
                const dotIndex = targetValue.indexOf('.');
                const afterDot = targetValue.substr(dotIndex + 1);

                if (afterDot.length === decimalPlaces && !allowedKeys.includes(keyPressed)) {
                    e.preventDefault();
                }
            }
        }
    }
}